<template>
  <div class="data">
    <span class="number" :style="{color: color}">{{ total }}</span>
    <div class="label">
      {{ label }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'SimpleIndicator',
  props: {
    total: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'black'
    }
  }
}

</script>

<style scoped lang="scss">

.data {
  display: flex;
  flex-direction: column;
}

.label {
  text-transform: capitalize;
}

.number {
  font-size: 45px;
}

</style>
